import { render, staticRenderFns } from "./TheVariantsSection.vue?vue&type=template&id=16d43955&scoped=true&name=the-variants-section&"
import script from "./TheVariantsSection.vue?vue&type=script&lang=js&"
export * from "./TheVariantsSection.vue?vue&type=script&lang=js&"
import style0 from "./TheVariantsSection.vue?vue&type=style&index=0&id=16d43955&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d43955",
  null
  
)

/* custom blocks */
import block0 from "./TheVariantsSection.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports